import React, { FC } from 'react';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import { translations } from '../strings';
import { Button } from 'antd';
import styles from './index.module.css';

type Props = {};

const PublicSuccess: FC<Props> = () => {
  const { locale, cancel } = usePublicFeedbackState();
  const strings = translations(locale);

  return (
    <div className={styles.messageOuter}>
      <div className={styles.successIcon} />
      <p className={styles.moreInfoMessage}>{strings.success_message}</p>
      <div className={styles.actionsContainer}>
        <Button type="primary" onClick={cancel} className={styles.action}>
          {strings.close}
        </Button>
      </div>
    </div>
  );
};

export default PublicSuccess;
